import React, { useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import * as XLSX from "xlsx";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useNavigate } from "react-router-dom";
import { Alert, Snackbar } from "@mui/material";
import { useLocation } from 'react-router-dom';
import { Modal, Button, Form } from "react-bootstrap";
import toastr from "toastr";


import uploadAndDownloadService from "../../../services/uploadAndDownloadFile";

import PurchaseService from "../../../services/PurchaseOrder";
import PopupChangePriceDocument from "./PopupChangePriceDocument";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";

const BDCNonConfirme = ({ listBDC, change }) => {
  const navigate = useNavigate();
  console.log("listBDC", listBDC);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [inConfirmedBdc, setInConfirmedBdc] = useState([]);
  const [updateDate, setUpdateData] = useState();
  const [newCreationDate, setNewCreationDate] = useState("");

  const [bdcUploadInformation, setBdcUploadInformation] = useState({
    reference: "any",
    state: 0,
    inConfirmedBdc: inConfirmedBdc,
  });
  const [onUploadFile, setOnUploadFile] = useState(false);
  const [onUpdatePrice, setOnUpdatePrice] = useState(false);
  const [selectedReference, setSelectedReference] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const { SearchBar } = Search;
  const MyExportExcel = () => {
    const handleExport = () => {
      const fmt = (v) => parseFloat(Number(v).toFixed(3));
      const rows = listBDC.map((row) => ({
        "Réf":         row.reference,
        "Fournisseur": row.supplierTitle,
        "P.A.HT":      fmt(row.buyingPrice),
        "P.A.TT":      fmt(row.ttPrice),
        "TVA":         fmt(Number(row.ttPrice) - Number(row.buyingPrice)),
      }));
      const ws = XLSX.utils.json_to_sheet(rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "BDC");
      XLSX.writeFile(wb, `bons_de_commande_${new Date().toISOString().split("T")[0]}.xlsx`);
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleExport}>
          <i className="fas fa-file-excel"></i> Télécharger Excel
        </button>
      </div>
    );
  };

  const onArchiveHandler = (refDocument, isDeleted) => {
    PurchaseService.deleteAndRestoreBDC(refDocument, isDeleted)
      .then((response) => {
        if (Object.keys(response.data)[0] === "success") {
          window.location.reload(false);
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });
  };
    // Open modal and set reference and current creation date
  const handleOpenModal = (reference, creationDate) => {
    setSelectedReference(reference);
    const date = new Date(creationDate);
    const formattedDate = date.toISOString().replace('T', ' ').slice(0, 19).replace(/ /g, 'T');
    setNewCreationDate(formattedDate);
    setShowModal(true);
  };

  function buttonDeleteFormatter(cell, row) {
    return (
            <div style={{ display: 'flex', gap: '8px' }}>

      <button
        style={{ width: 40 }}
        class="btn btn-danger btn-sm"
        onClick={() => onArchiveHandler(row.reference, 1)}
      >
        <i class="fas fa-trash"></i>
      </button>
        <button
          style={{ width: 30 }}
          className="btn btn-warning btn-sm"
          onClick={() => {
            console.log("row-------------------------------------->", row)
            handleOpenModal(row.reference, row.creationDate)
          }
          }
        >
          <i className="fas fa-edit"></i>
        </button>
        </div>
    );
  }

  const onUploadFileHandler = (state, reference, isDeleted) => {
    setBdcUploadInformation({
      reference: reference,
      state: state,
      bdcData: inConfirmedBdc,
      isDeleted: 0,
    });

    setOnUploadFile(true);
  };
  function buttonFileFormatter(cell, row) {
    if (row.path === "any") {
      return (
        <span>
          <button
            style={{ width: 40 }}
            class="btn bg-gray btn-sm text-center"
            onClick={() =>
              onUploadFileHandler(row.state, row.reference, row.isDeleted)
            }
          >
            <i class="fas fa-plus"></i>
          </button>
        </span>
      );
    } else if (row.path !== "any") {
      return (
        <button
          style={{ width: 40 }}
          class="btn bg-gray btn-sm "
          onClick={() =>
            onShowFileInOtherWizndowHandler(
              // UtilsUrl.sellingFileURL() +
              row.path
            )
          }
        >
          <i class="fas fa-eye"></i>
        </button>
      );
    }
  }
  const onEditPriceHandler = (reference, typeDocument) => {
    let updateData = {
      reference: reference,
      typeDocument: typeDocument,
    };
    setUpdateData(updateData);
    setOnUpdatePrice(true);
  };

  function buttonUpdatePriceFormatter(cell, row) {
      return (
        <span>
          <button
            style={{ width: 40 }}
            data-toggle="modal"
            data-target="#update-price"
            class="btn bg-gray btn-sm text-center"
            onClick={() =>
              onEditPriceHandler(row.reference, 2)
            }
          >
            <i class="fas fa-pencil"></i>
          </button>
        </span>
      );
   
  }
  const onViewFactureHistoriqueWarehousesHandler = (idDocument) => {
    sessionStorage.setItem("DocumentId", idDocument);
    sessionStorage.setItem("typeDocument", "BDC");

    navigate("/historiqueLivraison");
  };
  function buttonLivraisonFormatter(cell, row) {
    if (row.stateLivraison === 0) {
      return (
        <span style={{ cursor: "pointer" }} className="badge bg-warning">
          En attente
        </span>
      );
    } else if (row.stateLivraison === 1) {
      return (
        <a
          onClick={() => {
            onViewFactureHistoriqueWarehousesHandler(row.id);
          }}
        >
          <span style={{ cursor: "pointer" }} className="badge bg-primary">
            En cours
          </span>{" "}
        </a>
      );
    } else if (row.stateLivraison === 2) {
      return (
        <a
          onClick={() => {
            onViewFactureHistoriqueWarehousesHandler(row.id);
          }}
        >
          <span style={{ cursor: "pointer" }} className="badge bg-success">
            Terminé
          </span>{" "}
        </a>
      );
    }
  }

  function updatePriceFormatter(cell) {
   
      return (
        <>
          {extractDigitsAfterDecimal(cell)}
        </>
      );
 
  }
  function buttonDevisFormatter(cell, row) {
    if (row.devisReference !== "any") {
      return <span>{row.devisReference}</span>;
    } else {
      return (
        <span>
          <i class="fas fa-solid fa-ban"></i>
        </span>
      );
    }
  }
  const onAddTaxHandler = (id) => {
    sessionStorage.setItem("idTax", id);
    sessionStorage.setItem("typeToTax", "BC");
    navigate("/addTaxAndCharge");
  };
  function buttonChargeFormatter(cell, row) {
    return (
      <button
        style={{ width: 40 }}
        class="btn bg-gray-dark btn-sm "
        onClick={() => {
          console.log("element", row);
          onAddTaxHandler(row.reference);
        }}
      >
        <i class="fas fa-plus"></i>
      </button>
    );
  }
  const onViewProductsHandler = (refDocument, NoteDocument) => {
    sessionStorage.setItem("refDocument", refDocument);
    sessionStorage.setItem("typeDocument", "bdc");
    navigate("/getDocumentByRef");
  };

  function buttonDetailsFormatter(cell, row) {
    return (
      <button
        style={{ width: 40 }}
        class="btn bg-black btn-sm "
        onClick={() => onViewProductsHandler(row.reference, row.note)}
      >
        <i class="fas fa-shopping-cart"></i>
      </button>
    );
  }
  const onShowFileInOtherWizndowHandler = (path) => {
    uploadAndDownloadService
      .downloadFile(path)
      .then((response) => {
        //Build a URL from the file
        if (response.headers["content-type"] === "image/png") {
          const file = new Blob([response.data], { type: "image/png" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "application/pdf") {
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpeg") {
          const file = new Blob([response.data], { type: "image/jpeg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpg") {
          const file = new Blob([response.data], { type: "image/jpg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connexion");
      });
  };
  

  function extractDigitsAfterDecimal(number) {
    return parseFloat(Number(number).toFixed(3));
  }

  const columns = [
    {
      dataField: "reference",
      text: "Réf",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    {
      dataField: "supplierTitle",
      text: "Fournisseur",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "13%" };
      },
    },
    {
      dataField: "note",
      text: "Note",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "creationDate",
      text: "DC",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "buyingPrice",
      text: "P.A.HT",
      align: "center",
      headerAlign: "center",
      formatter: updatePriceFormatter,

      headerStyle: () => {
        return { width: "8%" };
      },
    },
    {
      dataField: "ttPrice",
      text: "P.A.TT",
      align: "center",
      formatter: updatePriceFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    {
      dataField: "tva_calc",
      isDummyField: true,
      text: "TVA",
      align: "center",
      headerAlign: "center",
      formatter: (cell, row) => parseFloat((Number(row.ttPrice) - Number(row.buyingPrice)).toFixed(3)),
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    {
      dataField: "devisReference",
      text: "Devis",
      align: "center",
      formatter: buttonDevisFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "7%" };
      },
    },
    {
      dataField: "path",
      text: "Fichier",
      formatter: buttonFileFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    }, {
      dataField: "id",
      text: "Modifier",
      formatter: buttonUpdatePriceFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    {
      dataField: "stateLivraison",
      text: "E.L",
      formatter: buttonLivraisonFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
      filter: selectFilter({
        options: {
          0: "En attente",
          1: "En cours",
          2: "Terminé",
        },
        placeholder: "Select ...",
        style: { fontSize: "12px" },
      }),
    },
    {
      dataField: "id",
      text: "Charge",
      formatter: buttonChargeFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    {
      dataField: "state",
      text: "Info",
      formatter: buttonDetailsFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "7%" };
      },
    },
    {
      dataField: "isDeleted",
      text: "Action",
      formatter: buttonDeleteFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    // {
    //   dataField: "reference",
    //   text: "Facture",
    //   formatter: buttonValidateFormatter,
    //   align: "center",
    //   headerAlign: "center",
    //   headerStyle: () => {
    //     return { width: "8%" };
    //   },
    // },
  ];

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  // function handleTableChange({ clients }) {
  //   if (change) {
  //     return clients;
  //   }
  // }
    const handleCloseModal = () => {
    setShowModal(false);
    setSelectedReference(null);
    setNewCreationDate("");
  };

  function handleTableChange({ clients }) {
    if (change) {
      return clients;
    }
  }
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };
  const handleSaveDate = () => {
    // console.log("Saving new date:", `${newCreationDate}`, "for reference:", selectedReference);
    PurchaseService.updateBonCommandeCreationDate(getCurrentUserId(), selectedReference, newCreationDate)
      .then((response) => {
        toastr.success("Bon de commande mis à jour avec succès")
        setShowModal(false);
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setShowModal(false);
        toastr.error("Erreur lors de la mise à jour du bon de commande");
      });
  };
  return (
    <div
      className="card card-outline card-dark mb-4"
      style={{ borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,.08)" }}
    >
      <div className="card-header">
        <h3 className="card-title">Les bons de commandes d'achat</h3>
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="id"
          data={listBDC}
          columns={columns}
          onTableChange={handleTableChange}
          search
        >
          {(props) => (
            <div>
              <div className="row ml-0">
                <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    style={{ color: "black" }}
                    placeholder="Chercher"
                  ></SearchBar>
                </div>
                <div className="ml-auto mr-0">
                  <MyExportExcel />
                </div>
              </div>
              <div className="row">
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  filter={filterFactory()}
                  headerClasses="thead-light"
                  wrapperClasses="table-responsive w-100"
                  striped
                  hover
                  condensed
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </div>


      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
      )}
{onUpdatePrice && (
        <PopupChangePriceDocument
          setOnUpdatePrice={setOnUpdatePrice}
          updateDate={updateDate}
        />
      )}
          <Modal show={showModal} onHide={handleCloseModal}>
              <Modal.Header closeButton>
                <Modal.Title>Modifier la Date de Création</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p><strong>Référence du bon de commande:</strong> {selectedReference}</p>
                <Form.Group>
                  <Form.Label>Modifier la Date de Création</Form.Label>
                  <Form.Control
                    type="datetime-local"
                    value={newCreationDate}
                    onChange={(e) => setNewCreationDate(e.target.value)}
                  />
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseModal}>
                  Annuler
                </Button>
                <Button variant="primary" onClick={handleSaveDate}>
                  Enregistrer
                </Button>
              </Modal.Footer>
            </Modal>
    </div>
  );
};
export default BDCNonConfirme;
